import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useOnScreen } from 'site-modules/shared/hooks/use-on-screen';

import './render-meatballs.scss';

export function RenderMeatballs({ sortedArray, onClick, classes = null, currentSlideIndex = 0 }) {
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0);
  const ref = useRef();
  const [isIntersecting] = useOnScreen(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  const handleOnClick = event => {
    const index = parseInt(event.target.getAttribute('data-index'), 10);
    ref.current.querySelector(`button:nth-child(${currentActiveIndex + 1})`).classList.remove('is-active');
    ref.current.querySelector(`button:nth-child(${index + 1})`).classList.add('is-active');
    setCurrentActiveIndex(index);
    onClick(event);
  };

  if (sortedArray.length < 2) return null;

  return (
    <section
      className={classnames('meatball-container d-flex justify-content-center mx-auto', classes, {
        'is-intersecting': isIntersecting,
      })}
      ref={ref}
    >
      {sortedArray.map((slide, index) => (
        <button
          className={classnames('m-0_25 p-0', {
            'is-active': currentSlideIndex === index,
          })}
          key={`${slide.href}`}
          onClick={handleOnClick}
          data-index={index}
          data-testid={`button-${index}`}
          tabIndex={-1}
        >
          {slide.title || slide.href}
        </button>
      ))}
    </section>
  );
}

RenderMeatballs.propTypes = {
  sortedArray: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.string,
  currentSlideIndex: PropTypes.number,
};
